exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-0082806c] {\n  max-width: 500px;\n}\n.modal-body--warning-section[data-v-0082806c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  gap: 10px;\n}\n.modal-body--warning-section .icon[data-v-0082806c] {\n    color: #ff9800;\n}\n.modal-body--warning-text[data-v-0082806c] {\n  font-size: 12px;\n  display: inline-block;\n  vertical-align: middle;\n}\n", ""]);

// exports
